import { IconEyeOff } from "@tabler/icons-react";

export const SessionsTableEmptyState = () => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-12 tw-px-4">
      <div className="tw-size-12 tw-rounded-full tw-bg-blue-50 tw-flex tw-items-center tw-justify-center tw-mb-3">
        <IconEyeOff className="tw-size-6 tw-text-blue-500" stroke={2} />
      </div>
      <h3 className="tw-font-sans tw-font-semibold tw-text-base tw-text-blue tw-mb-1">
        No sessions found
      </h3>
      <p className="tw-font-sans tw-font-normal tw-text-sm tw-text-blue-500 tw-text-center">
        Try adjusting your filters or search terms
      </p>
    </div>
  );
};

